export default {
  getAPI() {
    // return 'https://api.justwash.asia';
    // return 'http://localhost:8000';
    // return 'http://924e-49-48-136-179.ngrok.io';
    // return 'http://10.0.53.97';
    // return 'https://uat.justwash.asia';
    // return 'http://dev.justwash.asia';
    //return 'http://dev2.justwash.asia';
    //return 'http://192.168.5.34:8005';
    return '';
  }
}
